<template>
  <div
    class="z-10 h-14 md:h-15 aha-presentation-editor-header flex shadow-top items-center"
  >
    <span
      class="px-4 py-4 cursor-pointer"
      @click="showMenuMobile"
    >
      <aha-icon
        name="hamburger-menu"
        class="text-secondary-100"
      />
    </span>
    <div class="flex-grow text-right pr-2">
      <aha-button
        size="sm"
        @click="triggerPresent"
      >
        <aha-icon
          name="play"
          viewBox="0 0 24 24"
          width="15"
          height="15"
        />
        <span class="ml-1">Present with AhaSlides</span>
        <span class="h-6 border-r no-margin border-primary-100"></span>
        <span>
          <aha-icon
            name="arrow"
            width="14"
            height="14"
            viewBox="0 0 24 24"
          />
        </span>
      </aha-button>
    </div>

    <aha-context-menu ref="context-menu-present">
      <p class="context-menu-header">
        {{ $i18nPresenter.t('Present') }}
      </p>
      <div
        class="flex items-center pb-0 pr-2 rounded-t-lg sm:py-2 sm:pl-4 cursor-pointer"
        @click="handleGoogleSlidePresenting('present-now')"
      >
        <div class="flex flex-col items-start justify-start">
          <span class="mb-1 font-bold text-base-90">{{ $i18nPresenter.t('Present now') }}</span>
          <span class="text-xs text-base-80">{{ $i18nPresenter.t('Present from the current slide') }}</span>
        </div>
      </div>

      <div
        class="flex items-center py-4 cursor-pointer"
        @click="handleGoogleSlidePresenting('present-beginning')"
      >
        <div class="flex flex-col items-start justify-start">
          <span class="mb-1 font-bold text-base-90">{{ $i18nPresenter.t('Present from beginning') }}</span>
          <span class="text-xs text-base-80">{{ $i18nPresenter.t('Present from the first slide') }}</span>
        </div>
      </div>
    </aha-context-menu>
    <transition name="fade">
      <div
        @click="handleBackDropClick"
        class="fixed inset-0 z-10 hidden bg-base-100 opacity-20 md:block"
        v-if="showPresentOptions"
      />
    </transition>
    <aha-modal
      :hideHeader="true"
      :closable="false"
      :noCloseOnBackdrop="true"
      :noCloseOnEsc="true"
      :noScroll="true"
      v-if="isSyncPresentationGoogleSlide"
    >
      <div class="text-center">
        <aha-logo-loader :display-text="false" />
        <div class="mt-4">
          Please wait while we import your slides into AhaSlides.
          The presentation will open in a new tab, so please ensure popups are allowed.
        </div>
      </div>
    </aha-modal>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import GoogleSlideService from '@/services/google-slide'
import GoogleSlideApi from '@/api/googleSlide'
import config from '@/config'

export default {
  components: {
  },
  data() {
    return {
      showPresentOptions: false,
      isSyncPresentationGoogleSlide: false,
    }
  },

  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
    }),
    ...mapGetters('featureToggles', [
      'canUseGoogleSlideAddonSync',
    ]),
  },
  mounted() {

  },
  destroyed() {
  },
  methods: {
    showMenuMobile() {
      this.$store.state.indicators.isHomeSideBarShowing = true
    },
    triggerPresent() {
      if (!this.canUseGoogleSlideAddonSync) {
        window.open(`${config.presenterDomain}/presentation/${this.presentation.id}?presenting=true&presentFrom=google-slide`, '_blank')
        return
      }
      this.$refs['context-menu-present'].show()
    },
    async handleGoogleSlidePresenting(presentingFrom) {
      if (this.isSyncPresentationGoogleSlide) return
      this.isSyncPresentationGoogleSlide = true
      // await GoogleSlideService.setViewModeBeforeSync()
      const presentationGoogleSlideInfor = await GoogleSlideService.getPresentationGoogleSlide()
      const googleSlideActiveId = await GoogleSlideService.getGoogleSlideActiveId()
      const payload = {
        presentationId: this.presentation.id,
        googleSlideActiveId,
        presentingFrom,
        googleSlides: presentationGoogleSlideInfor.slides.map((item) => {
          return {
            id: item.id,
            order: item.index + 1,
            imageUrl: item.imageUrl,
          }
        }),
      }

      await GoogleSlideApi.syncGoogleSlides(payload)
      window.open(`${config.presenterDomain}/presentation/${this.presentation.id}?presenting=true&presentFrom=google-slide`, '_blank')
      this.isSyncPresentationGoogleSlide = false
    },
  },
}
</script>

<style lang="scss" scoped>
.aha-presentation-editor-header {
  background-color: #fff;
  position: sticky;
  top: 0;
}
</style>
